// Seikkailujen kirjausjono.
//
// Suoritettu seikkailu kirjataan palvelimelle jokaiselle osallistujalle erikseen
// (jokaisella pelaajalla on oma päiväkirjansa). Kirjaus voi epäonnistua, jos verkko
// katkeaa kesken metsäretken, joten se tallennetaan ensin puhelimeen ja lähetetään
// uudelleen, kunnes palvelin kuittaa. Palvelin tunnistaa saman seikkailun
// tunnisteesta, joten uudelleenlähetys ei tuplaa mitään.

const KEY = "adventureOutbox";

/** Virheet, joita uusiminen ei korjaa (tuntematon pelaaja, virheellinen kirjaus): jono hylkää ne. */
const FINAL = new Set([400, 404, 409, 422]);

export class AdventureOutbox {
  constructor({ api, storage }) {
    this.api = api;
    this.storage = storage;
    this.busy = false;
  }

  get items() {
    return this.storage.get(KEY, []);
  }

  /** Lisää kirjaukset jonoon; sama pelaaja + seikkailu ei mene kahdesti. */
  add(posts) {
    const items = this.items;
    for (const post of posts) {
      if (!items.some((x) => x.player === post.player && x.body.id === post.body.id)) items.push(post);
    }
    this.storage.set(KEY, items);
  }

  /**
   * Lähettää jonon. Palauttaa onnistuneet kirjaukset vastauksineen
   * ([{ player, body, result }]), jotta niistä voi ilmoittaa uudet merkit.
   * Päällekkäinen kutsu ei tee mitään.
   */
  async flush() {
    if (this.busy) return [];
    this.busy = true;
    const sent = [];
    try {
      for (const post of this.items) {
        if (this.api.canActAs && !this.api.canActAs(post.player)) continue;
        try {
          const result = await this.api.as(post.player).completeAdventure(post.body);
          sent.push({ ...post, result });
          this.#remove(post);
        } catch (e) {
          if (FINAL.has(e.status)) this.#remove(post); // ei koskaan onnistu: ei jäädä yrittämään
        }
      }
    } finally {
      this.busy = false;
    }
    return sent;
  }

  #remove(post) {
    this.storage.set(
      KEY,
      this.items.filter((x) => !(x.player === post.player && x.body.id === post.body.id)),
    );
  }
}

